/**
 * Build the request body for POST /api/auth/apply-crawl-data from a
 * (possibly-edited) WebsiteCrawlResult.
 *
 * Extracted so both PracticeIdentityStep and useCrawlConfirmation share
 * a single definition — no drift risk.
 */
import type { WebsiteCrawlResult } from '../types';

export interface ApplyCrawlDataPayload {
  clinic_type: string | null;
  specialties: string[];
  service_categories: string[];
  phone: string | null;
  email: string | null;
  address: string | null;
  timezone: string | null;
  telehealth_offered: boolean | null;
  modality: string | null;
  logo_url: string | null;
  brand_colors: string[];
  website_url: string;
  description: string | null;
  staff: {
    name: string;
    title: string | null;
    role: string | null;
    license_type: string[];
    degrees: string[];
    specialties: string[];
    bio: string | null;
    photo_url: string | null;
    photo_url_external: string | null;
    website_url: string | null;
  }[];
}

export function buildCrawlPayload(data: WebsiteCrawlResult): ApplyCrawlDataPayload {
  return {
    clinic_type: data.clinic_type,
    specialties: data.specialties,
    service_categories: data.service_categories ?? [],
    phone: data.phone,
    email: data.email,
    address: data.address,
    timezone: data.timezone,
    telehealth_offered: data.telehealth_offered,
    modality: data.modality ?? null,
    logo_url: data.logo_url,
    brand_colors: data.brand_colors,
    website_url: data.source_url,
    description: data.description,
    staff: (data.staff ?? []).map((s) => ({
      name: s.name,
      title: s.title,
      role: s.role,
      license_type: s.license_type,
      degrees: s.degrees ?? [],
      specialties: s.specialties ?? [],
      bio: s.bio,
      photo_url: s.photo_url_external ?? s.photo_url,
      photo_url_external: s.photo_url_external ?? null,
      website_url: s.website_url ?? null,
    })),
  };
}
